import { render, staticRenderFns } from "./resourcePlanningNew.vue?vue&type=template&id=36aafaf8&%3Aheight=mainHeight&"
import script from "./resourcePlanningNew.vue?vue&type=script&lang=js&"
export * from "./resourcePlanningNew.vue?vue&type=script&lang=js&"
import style0 from "./resourcePlanningNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports